import { toaster } from 'uikit/Toaster'
import { useMutation } from '@tanstack/react-query'
import { api } from 'api'

export const useUserItemCreate = () => {
  return useMutation({
    mutationFn: (data) => api.keycloak.createUserItem(data),
    onError: () => {
      toaster.create({
        title: 'Ошибка',
        description: 'Не удалось создать пользователя',
        type: 'error',
        duration: 9000,
        isClosable: true,
      })
    },
    onSuccess: () => {
      toaster.create({
        title: 'Готово',
        description: 'Пользователь успешно создан',
        type: 'success',
      })
    }
  })
}
